import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicClaimTypeDto extends EpimsBaseEntityDto {
  ClaimTypeName: string;
  ClaimAddress: string;
  ClaimPhoneNo: string;
  ClaimTypeEmail: string;
  SubscriberEmail: string;
  SubscriptionUserId: string;
  Version: number;
}
